// This function allow to reference all chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + {"2888":"35736bab5c2ac79d","3964":"260f728284d2fef3","8360":"2ac702a5cef895f1"}[chunkId] + ".css";
};